import { render, staticRenderFns } from "./OrderMy.vue?vue&type=template&id=9b811890"
import script from "./OrderMy.vue?vue&type=script&lang=js"
export * from "./OrderMy.vue?vue&type=script&lang=js"
import style0 from "./OrderMy.vue?vue&type=style&index=0&id=9b811890&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports